import { PlateRenderElementProps } from '@udecode/plate';
import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';

export const MultiColumnElement = ({
  attributes,
  children,
  nodeProps,
}: PlateRenderElementProps): JSX.Element => {
  return (
    <ErrorBoundary
      FallbackComponent={() => (
        <p contentEditable={false} className="p-10 mb-20 mt-10 bg-yellow-100">
          <span role="img" aria-label="Warning emoji">
            ⚠️
          </span>{' '}
          Something wrong with multi column! try remove and add new or report us this issue.
        </p>
      )}
    >
      <div {...attributes} {...nodeProps} className="flex overflow-y-hidden overflow-x-auto">
        {children}
      </div>
    </ErrorBoundary>
  );
};
